export const MENU: any = [
  // Please ignore this comment because in future we will use commented features
  {
    title: "Home",
    icon: {
      class: "fas fa-home",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/home/0",
  },
  //{
  //    title: 'Dashboard',
  //    icon: {
  //        class: 'fas fa-plus',
  //        bg: '#002244',
  //        color: '#FFFFFF'
  //    },
  //    path: '/dashboard',
  //},
  //{
  //    title: 'Report',
  //    icon: {
  //        class: 'fas fa-table',
  //        bg: '#002244',
  //        color: '#FFFFFF'
  //    },
  //    path: '/report'
  //},
  {
    title: "Master",
    icon: {
      class: "fas fa-star",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "1",
    sub: [
      {
        title: "Establish Office",
        icon: {
          class: "fas fa-building",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/officecreation",
        role: "1",
      },
      {
        title: "Manage Offices",
        icon: {
          class: "fas fa-building",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/manageoffices",
        role: "1",
      },
      {
        title: "Deactivated Offices",
        icon: {
          class: "fas fa-lock",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/deactivatedoffices",
        role: "1",
      },
    ],
  },
  // {
  //     title: 'DSC',
  //     icon: {
  //         class: 'fas fa-plus-circle',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/displaysubmenu',
  //     role: '1',
  //     sub: [{
  //         title: 'DSC Registration',
  //         icon: {
  //             class: 'fas fa-user-plus',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/dscregistration',
  //         role: '1'
  //     },
  //     {
  //         title: 'Manage DSC',
  //         icon: {
  //             class: 'fas fa-list',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/manage-dsc',
  //         role: '1'
  //     }]
  // },
  {
    title: "Users",
    icon: {
      class: "fas fa-user",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "1",
    sub: [
      {
        title: "Add Makers/Checkers",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/addusers",
        role: "1",
      },
      {
        title: "Manage Users",
        icon: {
          class: "fas fa-users",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/manage-users",
        role: "1",
      },
      {
        title: "Deactivated Users",
        icon: {
          class: "fas fa-user-lock",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/deactivateusers",
        role: "1",
      },
      {
        title: "Users List",
        icon: {
          class: "fas fa-list",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/list/2",
        role: "1",
      },
      // {
      //     title: 'Checkers List',
      //     icon: {
      //         class: 'fas fa-list',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/list/3',
      //     role: '1',
      // },
      {
        title: "Create Bulk User",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/bulkupload",
        role: "1",
      },
    ],
  },

  {
    title: "Accounting",
    icon: {
      class: "fas fa-wallet",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "1",
    sub: [
      {
        title: "Allocate Expenditure",
        icon: {
          class: "fas fa-wallet",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/allocateexpenditure",
        role: "1",
      },
      {
        title: "Expenditure Details",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/componentwise",
        role: "1",
      },
      {
        title: "Exp Pending Allot List",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingallote",
        role: "1",
      },
      {
        title: "Expenditure Approved List",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvedallotlist",
        role: "1",
      },
    ],
  },

  {
    title: "Accounting",
    icon: {
      class: "fas fa-wallet",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "5",
    sub: [
      {
        title: "Allocate Expenditure",
        icon: {
          class: "fas fa-wallet",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/allocateexpenditure",
        role: "5",
      },
      {
        title: "Expenditure Details",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/componentwise",
        role: "5",
      },
      {
        title: "Exp Pending Allot List",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingallote",
        role: "5",
      },
      {
        title: "Expenditure Approved List",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvedallotlist",
        role: "5",
      },
    ],
  },
  {
    title: "Vendor/Beneficiary",
    icon: {
      class: "fas fa-plus-circle",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "1",
    sub: [
      {
        title: "Add New Vendors",
        icon: {
          class: "fas fa-plus-circle",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/vendorregister",
        role: "1",
      },
      {
        title: "Approval Pending Vendors ",
        icon: {
          class: "fas fa-pause",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingvendorslist",
        role: "1",
      },
      {
        title: "Approved Vendors",
        icon: {
          class: "fas fa-user-check",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvedvendorslist",
        role: "1",
      },
    ],
  },
  {
    title: "Authorisation",
    icon: {
      class: "fas fa-plus-circle",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "1",
    sub: [
      // {
      //     title: 'Create Vendor Payment',
      //     icon: {
      //         class: 'fas fa-plus-circle',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/vendorpaymentcreation',
      //     role: '1'
      // },
      {
        title: "Approval Pending Expenditure",
        icon: {
          class: "fas fa-pause",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingpaymentlist",
        role: "1",
      },
      // {
      //     title: 'Approved Expenditure',
      //     icon: {
      //         class: 'fas fa-check',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/approvedpaymentlist',
      //     role: '1'
      // },
      {
        title: "Transaction History",
        icon: {
          class: "fas fa-check",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/transactionhistory",
        role: "1",
      },
    ],
  },

  // {
  //     title: 'Dsc Registration',
  //     icon: {
  //         class: 'fas fa-user-plus',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/dscregistration',
  //     role: '2'
  // },
  {
    title: "Vendor/Beneficiary",
    icon: {
      class: "fas fa-plus-circle",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "2",
    sub: [
      {
        title: "Add New Vendors",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/vendorregister",
        role: "4",
      },
      {
        title: "Approval Pending Vendors ",
        icon: {
          class: "fas fa-pause",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingvendorslist",
        role: "4",
      },
      {
        title: "Approved Vendors",
        icon: {
          class: "fas fa-user-check",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvedvendorslist",
        role: "4",
      },
    ],
  },
  {
    title: "Authorisation",
    icon: {
      class: "fas fa-wallet",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "2",
    sub: [
      {
        title: "Create Vendor Payment",
        icon: {
          class: "fas fa-plus-circle",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/vendorpaymentcreation",
        role: "2",
      },
      {
        title: "Approval Pending Expenditure",
        icon: {
          class: "fas fa-pause",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingpaymentlist",
        role: "2",
      },
      // {
      //     title: 'Approved Expenditure',
      //     icon: {
      //         class: 'fas fa-wallet',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/approvedpaymentlist',
      //     role: '2'
      // },
      {
        title: "Transaction History",
        icon: {
          class: "fas fa-wallet",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/transactionhistory",
        role: "2",
      },
    ],
  },

  //   {
  //     title: "Master",
  //     icon: {
  //       class: "fas fa-plus",
  //       bg: "#002244",
  //       color: "#FFFFFF",
  //     },
  //     path: "/displaysubmenu",
  //     role: "3",
  //     sub: [
  //       {
  //         title: "Establish Office",
  //         icon: {
  //           class: "fas fa-building",
  //           bg: "#002244",
  //           color: "#FFFFFF",
  //         },
  //         path: "/officecreation",
  //         role: "3",
  //       },
  //       {
  //         title: "Manage Offices",
  //         icon: {
  //           class: "fas fa-building",
  //           bg: "#002244",
  //           color: "#FFFFFF",
  //         },
  //         path: "/manageoffices",
  //         role: "3",
  //       },
  //       {
  //         title: "Deactivated Offices",
  //         icon: {
  //           class: "fas fa-lock",
  //           bg: "#002244",
  //           color: "#FFFFFF",
  //         },
  //         path: "/deactivatedoffices",
  //         role: "3",
  //       },
  //     ],
  //   },
  // {
  //     title: 'DSC',
  //     icon: {
  //         class: 'fas fa-plus-circle',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/displaysubmenu',
  //     role: '3',
  //     sub: [{
  //         title: 'DSC Registration',
  //         icon: {
  //             class: 'fas fa-user-plus',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/dscregistration',
  //         role: '3'
  //     },
  //     {
  //         title: 'Manage DSC',
  //         icon: {
  //             class: 'fas fa-list',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/manage-dsc',
  //         role: '3'
  //     }]
  // },
  //   {
  //     title: "Users",
  //     icon: {
  //       class: "fas fa-user",
  //       bg: "#002244",
  //       color: "#FFFFFF",
  //     },
  //     path: "/displaysubmenu",
  //     role: "3",
  //     sub: [
  //       {
  //         title: "Add Makers/Checkers",
  //         icon: {
  //           class: "fas fa-user-plus",
  //           bg: "#002244",
  //           color: "#FFFFFF",
  //         },
  //         path: "/addusers",
  //         role: "5",
  //       },
  //       {
  //         title: "Manage Users",
  //         icon: {
  //           class: "fas fa-users",
  //           bg: "#002244",
  //           color: "#FFFFFF",
  //         },
  //         path: "/manage-users",
  //         role: "5",
  //       },
  //       {
  //         title: "Deactivated Users",
  //         icon: {
  //           class: "fas fa-user-lock",
  //           bg: "#002244",
  //           color: "#FFFFFF",
  //         },
  //         path: "/deactivateusers",
  //         role: "5",
  //       },
  //       {
  //         title: "Users List",
  //         icon: {
  //           class: "fas fa-list",
  //           bg: "#002244",
  //           color: "#FFFFFF",
  //         },
  //         path: "/list/2",
  //         role: "5",
  //       },
  //       // {
  //       //     title: 'Checkers List',
  //       //     icon: {
  //       //         class: 'fas fa-list',
  //       //         bg: '#002244',
  //       //         color: '#FFFFFF'
  //       //     },
  //       //     path: '/list/3',
  //       //     role: '5',
  //       // },
  //       {
  //         title: "Create Bulk User",
  //         icon: {
  //           class: "fas fa-user-plus",
  //           bg: "#002244",
  //           color: "#FFFFFF",
  //         },
  //         path: "/bulkupload",
  //         role: "5",
  //       },
  //     ],
  //   },
  {
    title: "Accounting",
    icon: {
      class: "fas fa-wallet",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "3",
    sub: [
      //{
      //     title: 'Allocate Expenditure',
      //     icon: {
      //         class: 'fas fa-wallet',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/allocateexpenditure',
      //     role: '3'
      // },
      {
        title: "Component Wise Expenditure",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/componentwise",
        role: "3",
      },
    ],
  },

  {
    title: "Accounting",
    icon: {
      class: "fas fa-wallet",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "2",
    sub: [
      //{
      //     title: 'Allocate Expenditure',
      //     icon: {
      //         class: 'fas fa-wallet',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/allocateexpenditure',
      //     role: '3'
      // },
      {
        title: "Component Wise Expenditure",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/componentwise",
        role: "2",
      },
    ],
  },
  {
    title: "Vendor/Beneficiary",
    icon: {
      class: "fas fa-plus-circle",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "3",
    sub: [
      // {
      //     title: 'Add New Vendors',
      //     icon: {
      //         class: 'fas fa-plus-circle',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/vendorregister',
      //     role: '3'
      // },
      {
        title: "Approval Pending Vendors ",
        icon: {
          class: "fas fa-pause",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingvendorslist",
        role: "3",
      },
      {
        title: "Approved Vendors",
        icon: {
          class: "fas fa-user-check",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvedvendorslist",
        role: "3",
      },
    ],
  },
  {
    title: "Authorisation",
    icon: {
      class: "fas fa-plus-circle",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "3",
    sub: [
      // {
      //     title: 'Create Vendor Payment',
      //     icon: {
      //         class: 'fas fa-plus-circle',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/vendorpaymentcreation',
      //     role: '3'
      // },
      {
        title: "Approval Pending Expenditure",
        icon: {
          class: "fas fa-pause",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingpaymentlist",
        role: "3",
      },
      // {
      //     title: 'Approved Expenditure',
      //     icon: {
      //         class: 'fas fa-check',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/approvedpaymentlist',
      //     role: '3'
      // },
      {
        title: "Transaction History",
        icon: {
          class: "fas fa-check",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/transactionhistory",
        role: "3",
      },
    ],
  },

  // {
  //     title: 'DSC',
  //     icon: {
  //         class: 'fas fa-plus-circle',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/displaysubmenu',
  //     role: '4',
  //     sub: [
  //         {
  //             title: 'Dsc Registration',
  //             icon: {
  //                 class: 'fas fa-user-plus',
  //                 bg: '#002244',
  //                 color: '#FFFFFF'
  //             },
  //             path: '/dscregistration',
  //             role: '4'
  //         },
  //         {
  //             title: 'Manage DSC',
  //             icon: {
  //                 class: 'fas fa-list',
  //                 bg: '#002244',
  //                 color: '#FFFFFF'
  //             },
  //             path: '/manage-dsc',
  //             role: '4'
  //         }
  //     ]
  // },
  {
    title: "Users",
    icon: {
      class: "fas fa-user",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "4",
    sub: [
      {
        title: "Add Makers/Checkers",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/addusers",
        role: "4",
      },
      {
        title: "Manage Users",
        icon: {
          class: "fas fa-users",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/manage-users",
        role: "4",
      },
      {
        title: "Deactivated Users",
        icon: {
          class: "fas fa-user-lock",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/deactivateusers",
        role: "4",
      },
      {
        title: "Users List",
        icon: {
          class: "fas fa-list",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/list/2",
        role: "4",
      },
      // {
      //     title: 'Checkers List',
      //     icon: {
      //         class: 'fas fa-list',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/list/3',
      //     role: '4',
      // },
      {
        title: "Create Bulk User",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/bulkupload",
        role: "4",
      },
    ],
  },
  {
    title: "Accounting",
    icon: {
      class: "fas fa-wallet",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "4",
    sub: [
      //     {
      //     title: 'Allocate Expenditure',
      //     icon: {
      //         class: 'fas fa-wallet',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/allocateexpenditure',
      //     role: '4'
      // },
      {
        title: "Component Wise Expenditure",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/componentwise",
        role: "4",
      },
    ],
  },
  {
    title: "Vendor/Beneficiary",
    icon: {
      class: "fas fa-plus-circle",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "4",
    sub: [
      {
        title: "Add New Vendors",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/vendorregister",
        role: "4",
      },
      {
        title: "Approval Pending Vendors ",
        icon: {
          class: "fas fa-pause",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingvendorslist",
        role: "4",
      },
      {
        title: "Approved Vendors",
        icon: {
          class: "fas fa-user-check",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvedvendorslist",
        role: "4",
      },
    ],
  },
  {
    title: "Authorisation",
    icon: {
      class: "fas fa-plus-circle",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "4",
    sub: [
      {
        title: "Create Vendor Payment",
        icon: {
          class: "fas fa-plus-circle",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/vendorpaymentcreation",
        role: "4",
      },
      {
        title: "Approval Pending Expenditure",
        icon: {
          class: "fas fa-pause",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/approvalpendingpaymentlist",
        role: "4",
      },
      // {
      //     title: 'Approved Expenditure',
      //     icon: {
      //         class: 'fas fa-check',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/approvedpaymentlist',
      //     role: '4'
      // },
      {
        title: "Transaction History",
        icon: {
          class: "fas fa-check",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/transactoonhistory",
        role: "4",
      },
    ],
  },
  // {
  //     title: 'Vendors List ',
  //     icon: {
  //         class: 'fas fa-plus-circle',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/vendorslist'
  // },
  // {
  //     title: 'Change Password',
  //     icon: {
  //         class: 'fas fa-plus-circle',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/changepassword',
  // },
  // {
  //     title: 'Logout',
  //     icon: {
  //         class: 'fas fa-plus-circle',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/logout',
  // }
  {
    title: "Master",
    icon: {
      class: "fas fa-plus",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "5",
    sub: [
      {
        title: "Establish Office",
        icon: {
          class: "fas fa-building",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/officecreation",
        role: "5",
      },
      {
        title: "Manage Offices",
        icon: {
          class: "fas fa-building",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/manageoffices",
        role: "5",
      },
      {
        title: "Deactivated Offices",
        icon: {
          class: "fas fa-lock",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/deactivatedoffices",
        role: "5",
      },
    ],
  },
  {
    title: "Users",
    icon: {
      class: "fas fa-user",
      bg: "#002244",
      color: "#FFFFFF",
    },
    path: "/displaysubmenu",
    role: "5",
    sub: [
      {
        title: "Add Makers/Checkers",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/addusers",
        role: "1",
      },
      {
        title: "Manage Users",
        icon: {
          class: "fas fa-users",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/manage-users",
        role: "1",
      },
      {
        title: "Deactivated Users",
        icon: {
          class: "fas fa-user-lock",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/deactivateusers",
        role: "1",
      },
      {
        title: "Users List",
        icon: {
          class: "fas fa-list",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/list/2",
        role: "1",
      },
      // {
      //     title: 'Checkers List',
      //     icon: {
      //         class: 'fas fa-list',
      //         bg: '#002244',
      //         color: '#FFFFFF'
      //     },
      //     path: '/list/3',
      //     role: '1',
      // },
      {
        title: "Create Bulk User",
        icon: {
          class: "fas fa-user-plus",
          bg: "#002244",
          color: "#FFFFFF",
        },
        path: "/bulkupload",
        role: "1",
      },
    ],
  },
  // {
  //     title: 'Deduction',
  //     icon: {
  //         class: 'fas fa-wallet',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/displaysubmenu',
  //     role: '1',
  //     sub: [{

  //         title: 'Add Deduction',
  //         icon: {
  //             class: 'fas fa-plus-circle',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/addDeduction',
  //         role: '1'
  //     },
  //     {
  //         title: 'Deduction History',
  //         icon: {
  //             class: 'fas fa-history',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/deductionhistory',
  //         role: '1'

  //     }]
  // },
  // {
  //     title: 'Deduction',
  //     icon: {
  //         class: 'fas fa-wallet',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/displaysubmenu',
  //     role: '2',
  //     sub: [{

  //         title: 'Add Deduction',
  //         icon: {
  //             class: 'fas fa-plus-circle',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/addDeduction',
  //         role: '2'
  //     },
  //     {
  //         title: 'Deduction History',
  //         icon: {
  //             class: 'fas fa-history',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/deductionhistory',
  //         role: '2'

  //     }]
  // },
  // {
  //     title: 'Deduction',
  //     icon: {
  //         class: 'fas fa-wallet',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/displaysubmenu',
  //     role: '3',
  //     sub: [{

  //         title: 'Add Deduction',
  //         icon: {
  //             class: 'fas fa-plus-circle',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/addDeduction',
  //         role: '3'
  //     },
  //     {
  //         title: 'Deduction History',
  //         icon: {
  //             class: 'fas fa-history',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/deductionhistory',
  //         role: '3'

  //     }]
  // },
  // {
  //     title: 'Deduction',
  //     icon: {
  //         class: 'fas fa-wallet',
  //         bg: '#002244',
  //         color: '#FFFFFF'
  //     },
  //     path: '/displaysubmenu',
  //     role: '4',
  //     sub: [{

  //         title: 'Add Deduction',
  //         icon: {
  //             class: 'fas fa-plus-circle',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/addDeduction',
  //         role: '4'
  //     },
  //     {
  //         title: 'Deduction History',
  //         icon: {
  //             class: 'fas fa-history',
  //             bg: '#002244',
  //             color: '#FFFFFF'
  //         },
  //         path: '/deductionhistory',
  //         role: '4'

  //     }]
  // },
];
